// @flow

import BasicCondition from './basic_condition';
import PreyCondition from './prey_condition';
import HillCondition from './hill_condition';
import Settings from '@/lib/settings';

export default class {
  condition: any;

  constructor(args: Array<any>) {
    switch (args[0]) {
      case 'prey':
        this.condition = new PreyCondition(args[1]);
        break;
      case 'hill':
        this.condition = new HillCondition(
          args[1],
          args[2],
          args[3],
          args[4],
          args[5]
        );
        break;
      case '==':
      case '!=':
      case '<':
      case '<=':
      case '>':
      case '>=':
        this.condition = new BasicCondition(
          args[0],
          this.cast(args[1]),
          this.cast(args[2])
        );
        break;
      default:
        throw 'Unexpected condition';
    }
  }

  judge(value: any): boolean {
    return this.condition.judge(value);
  }

  calculate(value: any): number {
    return this.condition.calculate(value);
  }

  hasCalculate(): boolean {
    return !!this.condition.calculate;
  }

  cast(value: any): any {
    if (!Array.isArray(value)) return value;

    switch (value[0]) {
      case 'Settings':
        return Settings[value[1]];
      default:
        return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/condition/condition.js